import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { map, mergeMap } from 'rxjs';
import { StoryblokService } from 'src/app/services/storyblok.service';
import { ButtonDirective } from 'src/app/shared/directives/button.directive';
import { BlockStyle, BlockWrapperComponent } from 'src/app/storyblok/components/block-wrapper/block-wrapper.component';
import { ContextMenuComponent } from '../../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../../shared/components/svg/svg.component';
import { getFormatsFromFormatParam } from '../../get-formats-from-format-param';
import { ConversionFormat } from '../../templates/conversion-template/conversion-template.component';
import { ConversionFormatSelectMenuContentComponent } from '../conversion-format-select-menu-content/conversion-format-select-menu-content.component';

@Component({
  selector: 'app-conversion-format-switcher',
  standalone: true,
  templateUrl: './conversion-format-switcher.component.html',
  styleUrls: ['./conversion-format-switcher.component.scss'],
  imports: [
    CommonModule,
    BlockWrapperComponent,
    ButtonDirective,
    SvgComponent,
    ContextMenuComponent,
    RouterLink,
    ConversionFormatSelectMenuContentComponent,
  ],
})
export class ConversionFormatSwitcherComponent {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];

  private route = inject(ActivatedRoute);
  private storyblokService = inject(StoryblokService);

  allFromFormats$ = this.storyblokService.getStories({ content_type: 'ImageFormat' });
  allToFormats$ = this.storyblokService
    .getStories({ content_type: 'ImageFormat' })
    .pipe(map(formats => formats.filter(format => !(format as ConversionFormat).content.sourceOnly)));

  fromFormat$ = this.route.params.pipe(
    mergeMap(params => {
      return this.allFromFormats$.pipe(
        map(formats => {
          const slug = params.format?.split('-')[0];
          return formats.find(format => format.slug === slug) as ConversionFormat;
        })
      );
    })
  );

  toFormat$ = this.route.params.pipe(
    mergeMap(params => {
      return this.allFromFormats$.pipe(
        map(formats => {
          const { to: slug } = getFormatsFromFormatParam(params.format);
          return formats.find(format => format.slug === slug) as ConversionFormat;
        })
      );
    })
  );
}
